import * as React from 'react';
import { style } from 'typestyle';
import { vertical, center, startJustified } from 'csstips';
import { TrackTile } from './track-tile';
import { percent, px, viewWidth } from 'csx';
import { colorBrand } from '../theme/color';
import { mediaTablet, mediaMobileOnly } from '../theme/media';
import { Carousel } from './carousel';
import { observer } from 'mobx-react';
import { TrackSchema } from '../types/schema';
import { ImagePreloader } from '../types/fn';
import { AnalyticsController } from '../modules/analytics/controller';
import {
  constantTileCarouselAvailabilitySize,
  constantTileCarouselDesktopSize,
  constantTileCarouselMobileSize,
} from '../theme/constant';

export interface GenericCarouselTracksProps {
  tracks: Array<TrackSchema>;
  onClickLink(event: React.MouseEvent<any>): void;
  preload: ImagePreloader;
  PlayButton: any;
  AddRemove: any;
  Favourite: any;
  i18n?: {
    availableFor: string;
  };
  analytics: AnalyticsController;
}

const DEFAULT_I18N = {
  availableFor: 'Available for',
};

@observer
export class GenericCarouselTracks extends React.Component<GenericCarouselTracksProps, any> {
  render() {
    const {
      tracks,
      PlayButton,
      AddRemove,
      Favourite,
      onClickLink,
      i18n = DEFAULT_I18N,
      preload,
      analytics,
    } = this.props;

    return (
      <Carousel
        className={GenericCarouselTracks.styles.carousel}
        innerClassName={GenericCarouselTracks.styles.carouselInner}
        spacerClassName={GenericCarouselTracks.styles.carouselSpacer}
      >
        {tracks.map((track, index) => (
          <div key={index} className={GenericCarouselTracks.styles.trackContainer}>
            <TrackTile
              analytics={analytics}
              scale={1.2}
              track={track}
              PlayButton={PlayButton}
              AddRemove={AddRemove}
              Favourite={Favourite}
              onClickLink={onClickLink}
              className={GenericCarouselTracks.styles.track}
              preload={preload}
            />
            {track.expires_at && (
              <div className={GenericCarouselTracks.styles.availability}>
                {i18n.availableFor} <span>{track.expires_at.text}</span>
              </div>
            )}
          </div>
        ))}
      </Carousel>
    );
  }

  static styles = {
    carousel: style(
      mediaMobileOnly({ height: `calc(${constantTileCarouselMobileSize} + ${constantTileCarouselAvailabilitySize})` }),
      mediaTablet({ height: `calc(${constantTileCarouselDesktopSize} + ${constantTileCarouselAvailabilitySize})` }),
    ),
    carouselInner: style(mediaMobileOnly({ padding: '0 20px' }), mediaTablet({ padding: '0 40px' })),
    carouselSpacer: style({ flexShrink: 0 }, mediaMobileOnly({ width: px(20) }), mediaTablet({ width: px(40) })),
    trackContainer: style(
      {
        ...vertical,
        ...center,
        ...startJustified,
        position: 'relative',
        height: 'auto !important',
        flexShrink: 0,
        flexBasis: 'auto',
        marginRight: px(16),
      },
      mediaMobileOnly({ width: constantTileCarouselMobileSize }),
      mediaTablet({ width: constantTileCarouselDesktopSize }),
    ),
    track: style({
      height: 'auto !important',
      width: percent(100),
    }),
    availability: style({
      height: constantTileCarouselAvailabilitySize,
      lineHeight: constantTileCarouselAvailabilitySize,
      fontWeight: 'bold',
      $nest: { '&> span': { color: colorBrand.toString() } },
    }),
  };
}
